/**
 * Documents API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {FilterEnum} from 'Agent/AgentForms/Marketing/ducks/Marketing';
import globalAxios, {AxiosInstance, AxiosPromise} from 'axios';
import * as globalImportUrl from 'url';
// @ts-ignore
import {BASE_PATH, BaseAPI, RequestArgs, RequiredError} from './base';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from './common';
import {Configuration} from './configuration';

/**
 *
 * @export
 * @interface AgentFormOrderDTO
 */
export interface AgentFormOrderDTO {
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  lastUpdated?: string;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  orderDate?: string;
  /**
   *
   * @type {number}
   * @memberof AgentFormOrderDTO
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  orderStatus?: string;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  processingStatus?: string;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDTO
   */
  userName?: string;
}
/**
 *
 * @export
 * @interface FormCostCenter
 */
export interface FormCostCenter {
  /**
   *
   * @type {string}
   * @memberof FormCostCenter
   */
  costCenter?: string;
  /**
   *
   * @type {string}
   * @memberof FormCostCenter
   */
  costCenterDescription?: string;
  /**
   *
   * @type {number}
   * @memberof FormCostCenter
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof FormCostCenter
   */
  region?: string;
}
/**
 *
 * @export
 * @interface FormFedexAccounts
 */
export interface FormFedexAccounts {
  /**
   *
   * @type {string}
   * @memberof FormFedexAccounts
   */
  accountCity?: string;
  /**
   *
   * @type {string}
   * @memberof FormFedexAccounts
   */
  accountNumber?: string;
  /**
   *
   * @type {string}
   * @memberof FormFedexAccounts
   */
  accountState?: string;
  /**
   *
   * @type {number}
   * @memberof FormFedexAccounts
   */
  id?: number;
}

/**
 *
 * @export
 * @interface AgentFormOrderDetailDTO
 */
export interface AgentFormOrderDetailDTO {
  /**
   *
   * @type {number}
   * @memberof AgentFormOrderDetailDTO
   */
  fId?: number;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDetailDTO
   */
  formNumber?: string;
  /**
   *
   * @type {number}
   * @memberof AgentFormOrderDetailDTO
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof AgentFormOrderDetailDTO
   */
  product?: string;
  /**
   *
   * @type {number}
   * @memberof AgentFormOrderDetailDTO
   */
  quantity?: number;
}

/**
 *
 * @export
 * @interface AgentFormOrderRequestDTO
 */
export interface AgentFormOrderRequestDTO {
  /**
   *
   * @type {FormOrderShipping}
   * @memberof AgentFormOrderRequestDTO
   */
  formOrderShipping?: FormOrderShipping;
  /**
   *
   * @type {Array<FormShoppingCart>}
   * @memberof AgentFormOrderRequestDTO
   */
  formShoppingCartList?: Array<FormShoppingCart>;
  /**
   *
   * @type {number}
   * @memberof AgentFormOrderRequestDTO
   */
  userID?: number;
}

/**
 *
 * @export
 * @interface AgreementAcknowledgmentDto
 */
export interface AgreementAcknowledgmentDto {
  /**
   *
   * @type {string}
   * @memberof AgreementAcknowledgmentDto
   */
  agreementAcceptedDateKey: string;
  /**
   *
   * @type {Date}
   * @memberof AgreementAcknowledgmentDto
   */
  agreementAcceptedDate: Date;
}

/**
 *
 * @export
 * @interface URL
 */
export interface URL {
  /**
   *
   * @type {string}
   * @memberof URL
   */
  authority?: string;
  /**
   *
   * @type {object}
   * @memberof URL
   */
  content?: object;
  /**
   *
   * @type {number}
   * @memberof URL
   */
  defaultPort?: number;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  file?: string;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  host?: string;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  path?: string;
  /**
   *
   * @type {number}
   * @memberof URL
   */
  port?: number;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  protocol?: string;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  query?: string;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  ref?: string;
  /**
   *
   * @type {string}
   * @memberof URL
   */
  userInfo?: string;
}

/**
 *
 * @export
 * @interface FormOrderShipping
 */
export interface FormOrderShipping {
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  address1?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  address2?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  caseNameNumber?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  costCenter?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  fedExName?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  fedExNumber?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  notes?: string;
  /**
   *
   * @type {number}
   * @memberof FormOrderShipping
   */
  orderId?: number;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  rowguid?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  shipMode?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  shipTo?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  state?: string;
  /**
   *
   * @type {string}
   * @memberof FormOrderShipping
   */
  zipCode?: string;
}

/**
 *
 * @export
 * @interface FormShoppingCart
 */
export interface FormShoppingCart {
  /**
   *
   * @type {string}
   * @memberof FormShoppingCart
   */
  createDate?: string;
  /**
   *
   * @type {number}
   * @memberof FormShoppingCart
   */
  fid?: number;
  /**
   *
   * @type {number}
   * @memberof FormShoppingCart
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof FormShoppingCart
   */
  userId?: number;
}

/**
 *
 * @export
 * @interface InputStreamResource
 */
export interface InputStreamResource {
  /**
   *
   * @type {string}
   * @memberof InputStreamResource
   */
  description?: string;
  /**
   *
   * @type {any}
   * @memberof InputStreamResource
   */
  file?: any;
  /**
   *
   * @type {string}
   * @memberof InputStreamResource
   */
  filename?: string;
  /**
   *
   * @type {object}
   * @memberof InputStreamResource
   */
  inputStream?: object;
  /**
   *
   * @type {boolean}
   * @memberof InputStreamResource
   */
  open?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InputStreamResource
   */
  readable?: boolean;
  /**
   *
   * @type {string}
   * @memberof InputStreamResource
   */
  uri?: string;
  /**
   *
   * @type {URL}
   * @memberof InputStreamResource
   */
  url?: URL;
}

/**
 *
 * @export
 * @interface BulletinDto
 */
export interface BulletinDto {
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   */
  bulletinAccess?: string;
  /**
   *
   * @type {number}
   * @memberof BulletinDto
   */
  bulletinId?: number;
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   */
  channels?: string;
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   */
  createdOn?: string;
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   * @memberof BulletinDto
   */
  emailedOn?: string;
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof BulletinDto
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof InteractiveDTO
   */
  isNewYork?: boolean;
}

/**
 *
 * @export
 * @interface BulletinResponse
 */
export interface BulletinResponse {
  /**
   *
   * @type {number}
   * @memberof BulletinResponse
   */
  currentPageNumber?: number;
  /**
   *
   * @type {Array<BulletinDto>}
   * @memberof BulletinResponse
   */
  result?: Array<BulletinDto>;
  /**
   *
   * @type {number}
   * @memberof BulletinResponse
   */
  totalCount?: number;
}
/**
 *
 * @export
 * @interface MarketingPreviousOrderDTO
 */
export interface MarketingPreviousOrderDTO {
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  formId?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  formNumber?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  isFormPublished?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  orderDate?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  orderNumber?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  product?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingPreviousOrderDTO
   */
  quantity?: string;
  /**
   *
   * @type {number}
   * @memberof MarketingPreviousOrderDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof MarketingPreviousOrderDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof MarketingPreviousOrderDTO
   */
  unitIncrements?: number;
}
/**
 *
 * @export
 * @interface MarketingPreviousOrderResponse
 */
export interface MarketingPreviousOrderResponse {
  /**
   *
   * @type {number}
   * @memberof MarketingPreviousOrderResponse
   */
  currentPageNumber?: number;
  /**
   *
   * @type {Array<MarketingPreviousOrderDTO>}
   * @memberof MarketingPreviousOrderResponse
   */
  result?: Array<MarketingPreviousOrderDTO>;
  /**
   *
   * @type {number}
   * @memberof MarketingPreviousOrderResponse
   */
  totalCount?: number;
}
/**
 *
 * @export
 * @interface InteractiveDTO
 */
export interface InteractiveDTO {
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof InteractiveDTO
   */
  fId?: number;
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  formNumber?: string;
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  product?: string;
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  states?: string;
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof InteractiveDTO
   */
  category?: string;
  /**
   *
   * @type {boolean}
   * @memberof InteractiveDTO
   */
  isNewYork?: boolean;
}

/**
 *
 * @export
 * @interface InteractiveFormState
 */
export interface InteractiveFormState {
  /**
   *
   * @type {number}
   * @memberof InteractiveFormState
   */
  fid?: number;
  /**
   *
   * @type {string}
   * @memberof InteractiveFormState
   */
  stateCode?: string;
}

/**
 *
 * @export
 * @interface InteractiveResponse
 */
export interface InteractiveResponse {
  /**
   *
   * @type {number}
   * @memberof InteractiveResponse
   */
  currentPageNumber?: number;
  /**
   *
   * @type {Array<InteractiveDTO>}
   * @memberof InteractiveResponse
   */
  result?: Array<InteractiveDTO>;
  /**
   *
   * @type {number}
   * @memberof InteractiveResponse
   */
  totalCount?: number;
  /**
   *
   * @type {Array<FilterEnum>}
   * @memberof InteractiveResponse
   */
  interactiveFormsCategories?: FilterEnum[];
  /**
   *
   * @type {Array<FilterEnum>}
   * @memberof InteractiveResponse
   */
  interactiveFormsType?: FilterEnum[];
}

/**
 *
 * @export
 * @interface MarketingDTO
 */
export interface MarketingDTO {
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof MarketingDTO
   */
  fId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  formNumber?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  states?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof InteractiveDTO
   */
  isNewYork?: boolean;
  /**
   *
   * @type {string}
   * @memberof MarketingDTO
   */
  onlineOnly?: string;
  /**
   *
   * @type {number}
   * @memberof MarketingDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof MarketingDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof MarketingDTO
   */
  unitIncrements?: number;
}

/**
 *
 * @export
 * @interface MarketingFormState
 */
export interface MarketingFormState {
  /**
   *
   * @type {number}
   * @memberof MarketingFormState
   */
  fid?: number;
  /**
   *
   * @type {string}
   * @memberof MarketingFormState
   */
  statecode?: string;
}

/**
 *
 * @export
 * @interface MarketingResponse
 */
export interface MarketingResponse {
  /**
   *
   * @type {number}
   * @memberof MarketingResponse
   */
  currentPageNumber?: number;
  /**
   *
   * @type {Array<MarketingDTO>}
   * @memberof MarketingResponse
   */
  result?: Array<MarketingDTO>;
  /**
   *
   * @type {number}
   * @memberof MarketingResponse
   */
  totalCount?: number;
  /**
   *
   * @type {Array<FilterEnum>}
   * @memberof MarketingResponse
   */
  marketingFormsCategories?: FilterEnum[];
  /**
   *
   * @type {Array<FilterEnum>}
   * @memberof MarketingResponse
   */
  marketingFormsType?: FilterEnum[];
}

/**
 *
 * @export
 * @interface EnrollmentFileTemplateDto
 */
export interface EnrollmentFileTemplateDto {
  /**
   *
   * @type {number}
   * @memberof EnrollmentFileTemplateDto
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof EnrollmentFileTemplateDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof EnrollmentFileTemplateDto
   */
  documentFriendlyName?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnrollmentFileTemplateDto
   */
  acknowledgmentRequired: boolean;
}

/**
 *
 * @export
 * @interface FileDeleteCommand
 */
export interface FileDeleteCommand {
  /**
   *
   * @type {string}
   * @memberof FileDeleteCommand
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof FileDeleteCommand
   */
  fileSize?: string;
  /**
   *
   * @type {string}
   * @memberof FileDeleteCommand
   */
  filePath?: string;
  /**
   *
   * @type {string}
   * @memberof FileDeleteCommand
   */
  rowCount?: string;
  /**
   *
   * @type {string}
   * @memberof FileDeleteCommand
   */
  fileType?: string;
  /**
   *
   * @type {Date}
   * @memberof FileDeleteCommand
   */
  timeStamp: Date;
}

/**
 *
 * @export
 * @interface FileMetaData
 */
export interface FileMetaData {
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  fileName?: string;
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  fileSize?: string;
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  filePath?: string;
  /**
   *
   * @type {number}
   * @memberof FileMetaData
   */
  rowCount: number;
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  fileType?: string;
  /**
   *
   * @type {Date}
   * @memberof FileMetaData
   */
  timeStamp: Date;
  /**
   *
   * @type {number}
   * @memberof FileMetaData
   */
  templateId?: number;
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  uploadedByUserName?: string;
  /**
   *
   * @type {Date}
   * @memberof FileMetaData
   */
  agreementAcceptedDate?: Date;
  /**
   *
   * @type {Array<string>}
   * @memberof FileMetaData
   */
  fileContentErrors?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FileMetaData
   */
  groupId?: string;
}

/**
 *
 * @export
 * @interface FileUploadInProgressDto
 */
export interface FileUploadInProgressDto {
  /**
   *
   * @type {string}
   * @memberof FileUploadInProgressDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof FileUploadInProgressDto
   */
  fileName?: string;
}

/**
 * AgreementAcknowledgmentApi - axios parameter creator
 * @export
 */
export const AgreementAcknowledgmentApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acknowledge(version: string, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling acknowledge.'
        );
      }
      const localVarPath = `/api/v{version}/documents/upload/acknowledge`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AgreementAcknowledgmentApi - functional programming interface
 * @export
 */
export const AgreementAcknowledgmentApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acknowledge(
      version: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementAcknowledgmentDto> {
      const localVarAxiosArgs = AgreementAcknowledgmentApiAxiosParamCreator(configuration).acknowledge(
        version,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AgreementAcknowledgmentApi - factory interface
 * @export
 */
export const AgreementAcknowledgmentApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acknowledge(version: string, options?: any): AxiosPromise<AgreementAcknowledgmentDto> {
      return AgreementAcknowledgmentApiFp(configuration).acknowledge(version, options)(axios, basePath);
    },
  };
};

/**
 * AgreementAcknowledgmentApi - object-oriented interface
 * @export
 * @class AgreementAcknowledgmentApi
 * @extends {BaseAPI}
 */
export class AgreementAcknowledgmentApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementAcknowledgmentApi
   */
  public acknowledge(version: string, options?: any) {
    return AgreementAcknowledgmentApiFp(this.configuration).acknowledge(version, options)(this.axios, this.basePath);
  }
}

/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} friendlyName
     * @param {string} fileExtension
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportDocument(friendlyName: string, fileExtension: string, version: string, options: any = {}): RequestArgs {
      // verify required parameter 'friendlyName' is not null or undefined
      if (friendlyName === null || friendlyName === undefined) {
        throw new RequiredError(
          'friendlyName',
          'Required parameter friendlyName was null or undefined when calling exportDocument.'
        );
      }
      // verify required parameter 'fileExtension' is not null or undefined
      if (fileExtension === null || fileExtension === undefined) {
        throw new RequiredError(
          'fileExtension',
          'Required parameter fileExtension was null or undefined when calling exportDocument.'
        );
      }
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling exportDocument.'
        );
      }
      const localVarPath = `/api/v{version}/documents/{friendlyName}/export/{fileExtension}`
        .replace(`{${'friendlyName'}}`, encodeURIComponent(String(friendlyName)))
        .replace(`{${'fileExtension'}}`, encodeURIComponent(String(fileExtension)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} friendlyName
     * @param {string} fileExtension
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportDocument(
      friendlyName: string,
      fileExtension: string,
      version: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
      const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).exportDocument(
        friendlyName,
        fileExtension,
        version,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function(configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {string} friendlyName
     * @param {string} fileExtension
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportDocument(friendlyName: string, fileExtension: string, version: string, options?: any): AxiosPromise<any> {
      return DocumentsApiFp(configuration).exportDocument(
        friendlyName,
        fileExtension,
        version,
        options
      )(axios, basePath);
    },
  };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
  /**
   *
   * @param {string} friendlyName
   * @param {string} fileExtension
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentsApi
   */
  public exportDocument(friendlyName: string, fileExtension: string, version: string, options?: any) {
    return DocumentsApiFp(this.configuration).exportDocument(
      friendlyName,
      fileExtension,
      version,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * BulletinsControllerApi - axios parameter creator
 * @export
 */
export const BulletinsControllerApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @summary getBulletinbyID
     * @param {number} bulletinId bulletinId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulletinbyIDUsingGET: async (
      bulletinId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'bulletinId' is not null or undefined
      assertParamExists('getBulletinbyIDUsingGET', 'bulletinId', bulletinId);
      const localVarPath = `/v1/bulletins/{bulletinId}`.replace(
        `{${'bulletinId'}}`,
        encodeURIComponent(String(bulletinId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getBulletins
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [bulletinDateEndFilter] bulletinDateEndFilter
     * @param {string} [bulletinDateStartFilter] bulletinDateStartFilter
     * @param {string} [bulletinSubject] bulletinSubject
     * @param {string} [bulletinType] bulletinType
     * @param {string} [channels] channels
     * @param {string} [dateEmailedEndFilter] dateEmailedEndFilter
     * @param {string} [dateEmailedStartFilter] dateEmailedStartFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulletinsUsingGET: async (
      isNewYork?: boolean,
      bulletinDateEndFilter?: string,
      bulletinDateStartFilter?: string,
      bulletinSubject?: string,
      bulletinType?: string,
      channels?: string,
      dateEmailedEndFilter?: string,
      dateEmailedStartFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/bulletins`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (isNewYork !== undefined) {
        localVarQueryParameter['isNewYork'] = isNewYork;
      }

      if (bulletinDateEndFilter !== undefined) {
        localVarQueryParameter['createdEndDateFilter'] = bulletinDateEndFilter;
      }

      if (bulletinDateStartFilter !== undefined) {
        localVarQueryParameter['createdStartDateFilter'] = bulletinDateStartFilter;
      }

      if (bulletinSubject !== undefined) {
        localVarQueryParameter['bulletinSubject'] = bulletinSubject;
      }

      if (bulletinType !== undefined) {
        localVarQueryParameter['bulletinType'] = bulletinType;
      }

      if (channels !== undefined) {
        localVarQueryParameter['channels'] = channels;
      }

      if (dateEmailedEndFilter !== undefined) {
        localVarQueryParameter['emailedEndDateFilter'] = dateEmailedEndFilter;
      }

      if (dateEmailedStartFilter !== undefined) {
        localVarQueryParameter['emailedStartDateFilter'] = dateEmailedStartFilter;
      }

      if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sortColumn'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sortOrder'] = sortOrder;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BulletinsControllerApi - functional programming interface
 * @export
 */
export const BulletinsControllerApiFp = function(configuration?: Configuration) {
  const localVarAxiosParamCreator = BulletinsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary getBulletinbyID
     * @param {number} bulletinId bulletinId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBulletinbyIDUsingGET(
      bulletinId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBulletinbyIDUsingGET(
        bulletinId,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getBulletins
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [bulletinDateEndFilter] bulletinDateEndFilter
     * @param {string} [bulletinDateStartFilter] bulletinDateStartFilter
     * @param {string} [bulletinSubject] bulletinSubject
     * @param {string} [bulletinType] bulletinType
     * @param {string} [channels] channels
     * @param {string} [dateEmailedEndFilter] dateEmailedEndFilter
     * @param {string} [dateEmailedStartFilter] dateEmailedStartFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBulletinsUsingGET(
      isNewYork?: boolean,
      bulletinDateEndFilter?: string,
      bulletinDateStartFilter?: string,
      bulletinSubject?: string,
      bulletinType?: string,
      channels?: string,
      dateEmailedEndFilter?: string,
      dateEmailedStartFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulletinResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBulletinsUsingGET(
        isNewYork,
        bulletinDateEndFilter,
        bulletinDateStartFilter,
        bulletinSubject,
        bulletinType,
        channels,
        dateEmailedEndFilter,
        dateEmailedStartFilter,
        pageNumber,
        pageSize,
        sortColumn,
        sortOrder,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * BulletinsControllerApi - factory interface
 * @export
 */
export const BulletinsControllerApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BulletinsControllerApiFp(configuration);
  return {
    /**
     *
     * @summary getBulletinbyID
     * @param {number} bulletinId bulletinId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulletinbyIDUsingGET(
      bulletinId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<InputStreamResource> {
      return localVarFp
        .getBulletinbyIDUsingGET(bulletinId, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getBulletins
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [bulletinDateEndFilter] bulletinDateEndFilter
     * @param {string} [bulletinDateStartFilter] bulletinDateStartFilter
     * @param {string} [bulletinSubject] bulletinSubject
     * @param {string} [bulletinType] bulletinType
     * @param {string} [channels] channels
     * @param {string} [dateEmailedEndFilter] dateEmailedEndFilter
     * @param {string} [dateEmailedStartFilter] dateEmailedStartFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBulletinsUsingGET(
      isNewYork?: boolean,
      bulletinDateEndFilter?: string,
      bulletinDateStartFilter?: string,
      bulletinSubject?: string,
      bulletinType?: string,
      channels?: string,
      dateEmailedEndFilter?: string,
      dateEmailedStartFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<BulletinResponse> {
      return localVarFp
        .getBulletinsUsingGET(
          isNewYork,
          bulletinDateEndFilter,
          bulletinDateStartFilter,
          bulletinSubject,
          bulletinType,
          channels,
          dateEmailedEndFilter,
          dateEmailedStartFilter,
          pageNumber,
          pageSize,
          sortColumn,
          sortOrder,
          tokenValue,
          options
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BulletinsControllerApi - object-oriented interface
 * @export
 * @class BulletinsControllerApi
 * @extends {BaseAPI}
 */
export class BulletinsControllerApi extends BaseAPI {
  /**
   *
   * @summary getBulletinbyID
   * @param {number} bulletinId bulletinId
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BulletinsControllerApi
   */
  public getBulletinbyIDUsingGET(
    bulletinId: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return BulletinsControllerApiFp(this.configuration)
      .getBulletinbyIDUsingGET(bulletinId, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getBulletins
   * @param {boolean} [isNewYork] isNewYork
   * @param {string} [bulletinDateEndFilter] bulletinDateEndFilter
   * @param {string} [bulletinDateStartFilter] bulletinDateStartFilter
   * @param {string} [bulletinSubject] bulletinSubject
   * @param {string} [bulletinType] bulletinType
   * @param {string} [channels] channels
   * @param {string} [dateEmailedEndFilter] dateEmailedEndFilter
   * @param {string} [dateEmailedStartFilter] dateEmailedStartFilter
   * @param {string} [pageNumber] pageNumber
   * @param {string} [pageSize] pageSize
   * @param {string} [sortColumn] sortColumn
   * @param {string} [sortOrder] sortOrder
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BulletinsControllerApi
   */
  public getBulletinsUsingGET(
    isNewYork?: boolean,
    bulletinDateEndFilter?: string,
    bulletinDateStartFilter?: string,
    bulletinSubject?: string,
    bulletinType?: string,
    channels?: string,
    dateEmailedEndFilter?: string,
    dateEmailedStartFilter?: string,
    pageNumber?: string,
    pageSize?: string,
    sortColumn?: string,
    sortOrder?: string,
    tokenValue?: string,
    options?: any
  ) {
    return BulletinsControllerApiFp(this.configuration)
      .getBulletinsUsingGET(
        isNewYork,
        bulletinDateEndFilter,
        bulletinDateStartFilter,
        bulletinSubject,
        bulletinType,
        channels,
        dateEmailedEndFilter,
        dateEmailedStartFilter,
        pageNumber,
        pageSize,
        sortColumn,
        sortOrder,
        tokenValue,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * InteractiveFormControllerApi - axios parameter creator
 * @export
 */
export const InteractiveFormControllerApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @summary getInteractiveFormById
     * @param {number} id id
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormByIdUsingGET: async (
      id: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getInteractiveFormByIdUsingGET', 'id', id);
      const localVarPath = `/v1/interactiveForms/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getInteractiveFormsStates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormsStatesUsingGET: async (
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/interactiveForms/states`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fID !== undefined) {
        localVarQueryParameter['FID'] = fID;
      }

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getInteractiveForms
     * @param {string} [description] description
     * @param {string} [category] category
     * @param {string} [formNumber] formNumber
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormsUsingGET: async (
      description?: string,
      category?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      tokenValue?: string,
      type?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/interactiveForms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (description !== undefined) {
        localVarQueryParameter['description'] = description;
      }

      if (description !== undefined) {
        localVarQueryParameter['category'] = category;
      }

      if (formNumber !== undefined) {
        localVarQueryParameter['formNumber'] = formNumber;
      }

      if (isNewYork !== undefined) {
        localVarQueryParameter['isNewYork'] = isNewYork;
      }

      if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (product !== undefined) {
        localVarQueryParameter['product'] = product;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sortColumn'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sortOrder'] = sortOrder;
      }

      if (states !== undefined) {
        localVarQueryParameter['states'] = states;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InteractiveFormControllerApi - functional programming interface
 * @export
 */
export const InteractiveFormControllerApiFp = function(configuration?: Configuration) {
  const localVarAxiosParamCreator = InteractiveFormControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary getInteractiveFormById
     * @param {number} id id
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInteractiveFormByIdUsingGET(
      id: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInteractiveFormByIdUsingGET(
        id,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getInteractiveFormsStates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInteractiveFormsStatesUsingGET(
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InteractiveFormState>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInteractiveFormsStatesUsingGET(
        fID,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getInteractiveForms
     * @param {string} [description] description
     * @param {string} [category] category
     * @param {string} [formNumber] formNumber
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInteractiveFormsUsingGET(
      description?: string,
      category?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      tokenValue?: string,
      type?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteractiveResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getInteractiveFormsUsingGET(
        description,
        category,
        formNumber,
        isNewYork,
        pageNumber,
        pageSize,
        product,
        sortColumn,
        sortOrder,
        states,
        tokenValue,
        type,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * InteractiveFormControllerApi - factory interface
 * @export
 */
export const InteractiveFormControllerApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InteractiveFormControllerApiFp(configuration);
  return {
    /**
     *
     * @summary getInteractiveFormById
     * @param {number} id id
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormByIdUsingGET(
      id: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<InputStreamResource> {
      return localVarFp
        .getInteractiveFormByIdUsingGET(id, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getInteractiveFormsStates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormsStatesUsingGET(
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<InteractiveFormState>> {
      return localVarFp
        .getInteractiveFormsStatesUsingGET(fID, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getInteractiveForms
     * @param {string} [description] description
     * @param {string} [formNumber] formNumber
     * @param {string} [category] category
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInteractiveFormsUsingGET(
      description?: string,
      category?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      tokenValue?: string,
      type?: string,
      options?: any
    ): AxiosPromise<InteractiveResponse> {
      return localVarFp
        .getInteractiveFormsUsingGET(
          description,
          category,
          formNumber,
          isNewYork,
          pageNumber,
          pageSize,
          product,
          sortColumn,
          sortOrder,
          states,
          tokenValue,
          type,
          options
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InteractiveFormControllerApi - object-oriented interface
 * @export
 * @class InteractiveFormControllerApi
 * @extends {BaseAPI}
 */
export class InteractiveFormControllerApi extends BaseAPI {
  /**
   *
   * @summary getInteractiveFormById
   * @param {number} id id
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InteractiveFormControllerApi
   */
  public getInteractiveFormByIdUsingGET(
    id: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return InteractiveFormControllerApiFp(this.configuration)
      .getInteractiveFormByIdUsingGET(id, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getInteractiveFormsStates
   * @param {number} [fID] FID
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InteractiveFormControllerApi
   */
  public getInteractiveFormsStatesUsingGET(
    fID?: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return InteractiveFormControllerApiFp(this.configuration)
      .getInteractiveFormsStatesUsingGET(fID, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getInteractiveForms
   * @param {string} [description] description
   * @param {string} [formNumber] formNumber
   * @param {boolean} [isNewYork] isNewYork
   * @param {string} [category] category
   * @param {string} [pageNumber] pageNumber
   * @param {string} [pageSize] pageSize
   * @param {string} [product] product
   * @param {string} [sortColumn] sortColumn
   * @param {string} [sortOrder] sortOrder
   * @param {string} [states] states
   * @param {string} [tokenValue]
   * @param {string} [type] type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InteractiveFormControllerApi
   */
  public getInteractiveFormsUsingGET(
    description?: string,
    category?: string,
    formNumber?: string,
    isNewYork?: boolean,
    pageNumber?: string,
    pageSize?: string,
    product?: string,
    sortColumn?: string,
    sortOrder?: string,
    states?: string,
    tokenValue?: string,
    type?: string,
    options?: any
  ) {
    return InteractiveFormControllerApiFp(this.configuration)
      .getInteractiveFormsUsingGET(
        description,
        category,
        formNumber,
        isNewYork,
        pageNumber,
        pageSize,
        product,
        sortColumn,
        sortOrder,
        states,
        tokenValue,
        type,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MarketingFormControllerApi - axios parameter creator
 * @export
 */
export const MarketingFormControllerApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @summary getInteractiveFormByFId
     * @param {number} fID FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormByFIdUsingGET: async (
      fID: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fID' is not null or undefined
      assertParamExists('getMarketingFormByFIdUsingGET', 'fID', fID);
      const localVarPath = `/v1/marketingForms/all/{FID}`.replace(`{${'FID'}}`, encodeURIComponent(String(fID)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of Fedex accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsFedexAccountsUsingGET: async (
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms/fedexAccounts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Order details by OrderId
     * @param {number} orderId orderId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsOrderDetailsUsingGET: async (
      orderId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists('getMarketingFormsOrderDetailsUsingGET', 'orderId', orderId);
      const localVarPath = `/v1/marketingForms/orders/{orderId}`.replace(
        `{${'orderId'}}`,
        encodeURIComponent(String(orderId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of cost center accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsCostCentersUsingGET: async (
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms/costCenterAccounts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Orders submitted by user
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsOrdersUsingGET: async (
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms/orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getMarketingForms
     * @param {string} [category] category
     * @param {string} [description] description
     * @param {string} [formNumber] formNumber
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [title] title
     * @param {string} [titleOrType] titleOrType
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsUsingGET: async (
      category?: string,
      description?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      title?: string,
      tokenValue?: string,
      type?: string,
      titleOrType?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (category !== undefined) {
        localVarQueryParameter['category'] = category;
      }

      if (description !== undefined) {
        localVarQueryParameter['description'] = description;
      }

      if (formNumber !== undefined) {
        localVarQueryParameter['formNumber'] = formNumber;
      }

      if (isNewYork !== undefined) {
        localVarQueryParameter['isNewYork'] = isNewYork;
      }

      if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sortColumn'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sortOrder'] = sortOrder;
      }

      if (states !== undefined) {
        localVarQueryParameter['states'] = states;
      }

      if (title !== undefined) {
        localVarQueryParameter['title'] = title;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (titleOrType !== undefined) {
        localVarQueryParameter['titleOrType'] = titleOrType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getMarketingFormsstates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsstateUsingGET: async (
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms/states`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fID !== undefined) {
        localVarQueryParameter['FID'] = fID;
      }

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary getMarketingPreviousOrders
     * @param {object} [claims]
     * @param {string} [formNumber] formNumber
     * @param {object} [headers]
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [orderEndDateFilter] orderEndDateFilter
     * @param {string} [orderNumber] orderNumber
     * @param {string} [orderStartDateFilter] orderStartDateFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [quantity] quantity
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingPreviousOrdersUsingGET: async (
      claims?: object,
      formNumber?: string,
      headers?: object,
      isNewYork?: boolean,
      orderEndDateFilter?: string,
      orderNumber?: string,
      orderStartDateFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      quantity?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/marketingForms/orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (formNumber !== undefined) {
        localVarQueryParameter['formNumber'] = formNumber;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (isNewYork !== undefined) {
        localVarQueryParameter['isNewYork'] = isNewYork;
      }

      if (orderEndDateFilter !== undefined) {
        localVarQueryParameter['orderEndDateFilter'] =
          (orderEndDateFilter as any) instanceof Date ? (orderEndDateFilter as any).toISOString() : orderEndDateFilter;
      }

      if (orderNumber !== undefined) {
        localVarQueryParameter['orderNumber'] = orderNumber;
      }

      if (orderStartDateFilter !== undefined) {
        localVarQueryParameter['orderStartDateFilter'] =
          (orderStartDateFilter as any) instanceof Date
            ? (orderStartDateFilter as any).toISOString()
            : orderStartDateFilter;
      }

      if (pageNumber !== undefined) {
        localVarQueryParameter['pageNumber'] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
      }

      if (product !== undefined) {
        localVarQueryParameter['product'] = product;
      }

      if (quantity !== undefined) {
        localVarQueryParameter['quantity'] = quantity;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sortColumn'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sortOrder'] = sortOrder;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Submit Marketing Order
     * @param {AgentFormOrderRequestDTO} agentFormOrderRequestDTO agentFormOrderRequestDTO
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ submitFormOrderUsingPOST: async (
      agentFormOrderRequestDTO: AgentFormOrderRequestDTO,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentFormOrderRequestDTO' is not null or undefined
      assertParamExists('submitFormOrderUsingPOST', 'agentFormOrderRequestDTO', agentFormOrderRequestDTO);
      const localVarPath = `/v1/marketingForms/submitOrder`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (claims !== undefined) {
        localVarQueryParameter['claims'] = claims;
      }

      if (headers !== undefined) {
        localVarQueryParameter['headers'] = headers;
      }

      if (tokenValue !== undefined) {
        localVarQueryParameter['tokenValue'] = tokenValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        agentFormOrderRequestDTO,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketingFormControllerApi - functional programming interface
 * @export
 */
export const MarketingFormControllerApiFp = function(configuration?: Configuration) {
  const localVarAxiosParamCreator = MarketingFormControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary getInteractiveFormByFId
     * @param {number} fID FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormByFIdUsingGET(
      fID: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormByFIdUsingGET(
        fID,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary List of cost center accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsCostCentersUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormCostCenter>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsCostCentersUsingGET(
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary List of Fedex accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsFedexAccountsUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormFedexAccounts>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsFedexAccountsUsingGET(
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Order details by OrderId
     * @param {number} orderId orderId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsOrderDetailsUsingGET(
      orderId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentFormOrderDetailDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsOrderDetailsUsingGET(
        orderId,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Orders submitted by user
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsOrdersUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentFormOrderDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsOrdersUsingGET(
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getMarketingForms
     * @param {string} [category] category
     * @param {string} [description] description
     * @param {string} [formNumber] formNumber
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [title] title
     * @param {string} [titleOrType] titleOrType
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsUsingGET(
      category?: string,
      description?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      title?: string,
      tokenValue?: string,
      type?: string,
      titleOrType?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsUsingGET(
        category,
        description,
        formNumber,
        isNewYork,
        pageNumber,
        pageSize,
        sortColumn,
        sortOrder,
        states,
        title,
        tokenValue,
        type,
        titleOrType,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getMarketingFormsstates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingFormsstateUsingGET(
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MarketingFormState>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingFormsstateUsingGET(
        fID,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary getMarketingPreviousOrders
     * @param {object} [claims]
     * @param {string} [formNumber] formNumber
     * @param {object} [headers]
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [orderEndDateFilter] orderEndDateFilter
     * @param {string} [orderNumber] orderNumber
     * @param {string} [orderStartDateFilter] orderStartDateFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [quantity] quantity
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMarketingPreviousOrdersUsingGET(
      claims?: object,
      formNumber?: string,
      headers?: object,
      isNewYork?: boolean,
      orderEndDateFilter?: string,
      orderNumber?: string,
      orderStartDateFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      quantity?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingPreviousOrderResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingPreviousOrdersUsingGET(
        claims,
        formNumber,
        headers,
        isNewYork,
        orderEndDateFilter,
        orderNumber,
        orderStartDateFilter,
        pageNumber,
        pageSize,
        product,
        quantity,
        sortColumn,
        sortOrder,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     *
     * @summary Submit Marketing Order
     * @param {AgentFormOrderRequestDTO} agentFormOrderRequestDTO agentFormOrderRequestDTO
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submitFormOrderUsingPOST(
      agentFormOrderRequestDTO: AgentFormOrderRequestDTO,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFormOrderDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.submitFormOrderUsingPOST(
        agentFormOrderRequestDTO,
        claims,
        headers,
        tokenValue,
        options
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * MarketingFormControllerApi - factory interface
 * @export
 */
export const MarketingFormControllerApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MarketingFormControllerApiFp(configuration);
  return {
    /**
     *
     * @summary getInteractiveFormByFId
     * @param {number} fID FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormByFIdUsingGET(
      fID: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<InputStreamResource> {
      return localVarFp
        .getMarketingFormByFIdUsingGET(fID, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List of cost center accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsCostCentersUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<FormCostCenter>> {
      return localVarFp
        .getMarketingFormsCostCentersUsingGET(claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List of Fedex accounts
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsFedexAccountsUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<FormFedexAccounts>> {
      return localVarFp
        .getMarketingFormsFedexAccountsUsingGET(claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Order details by OrderId
     * @param {number} orderId orderId
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsOrderDetailsUsingGET(
      orderId: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<AgentFormOrderDetailDTO>> {
      return localVarFp
        .getMarketingFormsOrderDetailsUsingGET(orderId, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Orders submitted by user
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsOrdersUsingGET(
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<AgentFormOrderDTO>> {
      return localVarFp
        .getMarketingFormsOrdersUsingGET(claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getMarketingForms
     * @param {string} [category] category
     * @param {string} [description] description
     * @param {string} [formNumber] formNumber
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [states] states
     * @param {string} [title] title
     * @param {string} [titleOrType] titleOrType
     * @param {string} [tokenValue]
     * @param {string} [type] type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsUsingGET(
      category?: string,
      description?: string,
      formNumber?: string,
      isNewYork?: boolean,
      pageNumber?: string,
      pageSize?: string,
      sortColumn?: string,
      sortOrder?: string,
      states?: string,
      title?: string,
      tokenValue?: string,
      type?: string,
      titleOrType?: string,
      options?: any
    ): AxiosPromise<MarketingResponse> {
      return localVarFp
        .getMarketingFormsUsingGET(
          category,
          description,
          formNumber,
          isNewYork,
          pageNumber,
          pageSize,
          sortColumn,
          sortOrder,
          states,
          title,
          tokenValue,
          type,
          titleOrType,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getMarketingFormsstates
     * @param {number} [fID] FID
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingFormsstateUsingGET(
      fID?: number,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<Array<MarketingFormState>> {
      return localVarFp
        .getMarketingFormsstateUsingGET(fID, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary getMarketingPreviousOrders
     * @param {object} [claims]
     * @param {string} [formNumber] formNumber
     * @param {object} [headers]
     * @param {boolean} [isNewYork] isNewYork
     * @param {string} [orderEndDateFilter] orderEndDateFilter
     * @param {string} [orderNumber] orderNumber
     * @param {string} [orderStartDateFilter] orderStartDateFilter
     * @param {string} [pageNumber] pageNumber
     * @param {string} [pageSize] pageSize
     * @param {string} [product] product
     * @param {string} [quantity] quantity
     * @param {string} [sortColumn] sortColumn
     * @param {string} [sortOrder] sortOrder
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMarketingPreviousOrdersUsingGET(
      claims?: object,
      formNumber?: string,
      headers?: object,
      isNewYork?: boolean,
      orderEndDateFilter?: string,
      orderNumber?: string,
      orderStartDateFilter?: string,
      pageNumber?: string,
      pageSize?: string,
      product?: string,
      quantity?: string,
      sortColumn?: string,
      sortOrder?: string,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<MarketingPreviousOrderResponse> {
      return localVarFp
        .getMarketingPreviousOrdersUsingGET(
          claims,
          formNumber,
          headers,
          isNewYork,
          orderEndDateFilter,
          orderNumber,
          orderStartDateFilter,
          pageNumber,
          pageSize,
          product,
          quantity,
          sortColumn,
          sortOrder,
          tokenValue,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Submit Marketing Order
     * @param {AgentFormOrderRequestDTO} agentFormOrderRequestDTO agentFormOrderRequestDTO
     * @param {object} [claims]
     * @param {object} [headers]
     * @param {string} [tokenValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitFormOrderUsingPOST(
      agentFormOrderRequestDTO: AgentFormOrderRequestDTO,
      claims?: object,
      headers?: object,
      tokenValue?: string,
      options?: any
    ): AxiosPromise<AgentFormOrderDTO> {
      return localVarFp
        .submitFormOrderUsingPOST(agentFormOrderRequestDTO, claims, headers, tokenValue, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MarketingFormControllerApi - object-oriented interface
 * @export
 * @class MarketingFormControllerApi
 * @extends {BaseAPI}
 */
export class MarketingFormControllerApi extends BaseAPI {
  /**
   *
   * @summary getInteractiveFormByFId
   * @param {number} fID FID
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormByFIdUsingGET(
    fID: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormByFIdUsingGET(fID, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of cost center accounts
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsCostCentersUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsCostCentersUsingGET(claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of Fedex accounts
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsFedexAccountsUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsFedexAccountsUsingGET(claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Order details by OrderId
   * @param {number} orderId orderId
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsOrderDetailsUsingGET(
    orderId: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsOrderDetailsUsingGET(orderId, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Orders submitted by user
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsOrdersUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsOrdersUsingGET(claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getMarketingForms
   * @param {string} [category] category
   * @param {string} [description] description
   * @param {string} [formNumber] formNumber
   * @param {boolean} [isNewYork] isNewYork
   * @param {string} [pageNumber] pageNumber
   * @param {string} [pageSize] pageSize
   * @param {string} [sortColumn] sortColumn
   * @param {string} [sortOrder] sortOrder
   * @param {string} [states] states
   * @param {string} [title] title
   * @param {string} [titleOrType] titleOrType
   * @param {string} [tokenValue]
   * @param {string} [type] type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsUsingGET(
    category?: string,
    description?: string,
    formNumber?: string,
    isNewYork?: boolean,
    pageNumber?: string,
    pageSize?: string,
    sortColumn?: string,
    sortOrder?: string,
    states?: string,
    title?: string,
    tokenValue?: string,
    type?: string,
    titleOrType?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsUsingGET(
        category,
        description,
        formNumber,
        isNewYork,
        pageNumber,
        pageSize,
        sortColumn,
        sortOrder,
        states,
        title,
        tokenValue,
        type,
        titleOrType,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getMarketingFormsstates
   * @param {number} [fID] FID
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingFormsstateUsingGET(
    fID?: number,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingFormsstateUsingGET(fID, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary getMarketingPreviousOrders
   * @param {object} [claims]
   * @param {string} [formNumber] formNumber
   * @param {object} [headers]
   * @param {boolean} [isNewYork] isNewYork
   * @param {string} [orderEndDateFilter] orderEndDateFilter
   * @param {string} [orderNumber] orderNumber
   * @param {string} [orderStartDateFilter] orderStartDateFilter
   * @param {string} [pageNumber] pageNumber
   * @param {string} [pageSize] pageSize
   * @param {string} [product] product
   * @param {string} [quantity] quantity
   * @param {string} [sortColumn] sortColumn
   * @param {string} [sortOrder] sortOrder
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public getMarketingPreviousOrdersUsingGET(
    claims?: object,
    formNumber?: string,
    headers?: object,
    isNewYork?: boolean,
    orderEndDateFilter?: string,
    orderNumber?: string,
    orderStartDateFilter?: string,
    pageNumber?: string,
    pageSize?: string,
    product?: string,
    quantity?: string,
    sortColumn?: string,
    sortOrder?: string,
    tokenValue?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .getMarketingPreviousOrdersUsingGET(
        claims,
        formNumber,
        headers,
        isNewYork,
        orderEndDateFilter,
        orderNumber,
        orderStartDateFilter,
        pageNumber,
        pageSize,
        product,
        quantity,
        sortColumn,
        sortOrder,
        tokenValue,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Submit Marketing Order
   * @param {AgentFormOrderRequestDTO} agentFormOrderRequestDTO agentFormOrderRequestDTO
   * @param {object} [claims]
   * @param {object} [headers]
   * @param {string} [tokenValue]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketingFormControllerApi
   */
  public submitFormOrderUsingPOST(
    agentFormOrderRequestDTO: AgentFormOrderRequestDTO,
    claims?: object,
    headers?: object,
    tokenValue?: string,
    options?: any
  ) {
    return MarketingFormControllerApiFp(this.configuration)
      .submitFormOrderUsingPOST(agentFormOrderRequestDTO, claims, headers, tokenValue, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * EnrollmentFileTemplateApi - axios parameter creator
 * @export
 */
export const EnrollmentFileTemplateApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplates(version: string, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling getTemplates.'
        );
      }
      const localVarPath = `/api/v{version}/documents/applications/templates`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnrollmentFileTemplateApi - functional programming interface
 * @export
 */
export const EnrollmentFileTemplateApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplates(
      version: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnrollmentFileTemplateDto>> {
      const localVarAxiosArgs = EnrollmentFileTemplateApiAxiosParamCreator(configuration).getTemplates(
        version,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * EnrollmentFileTemplateApi - factory interface
 * @export
 */
export const EnrollmentFileTemplateApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTemplates(version: string, options?: any): AxiosPromise<Array<EnrollmentFileTemplateDto>> {
      return EnrollmentFileTemplateApiFp(configuration).getTemplates(version, options)(axios, basePath);
    },
  };
};

/**
 * EnrollmentFileTemplateApi - object-oriented interface
 * @export
 * @class EnrollmentFileTemplateApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileTemplateApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnrollmentFileTemplateApi
   */
  public getTemplates(version: string, options?: any) {
    return EnrollmentFileTemplateApiFp(this.configuration).getTemplates(version, options)(this.axios, this.basePath);
  }
}

/**
 * EnrollmentFileUploadApi - axios parameter creator
 * @export
 */
export const EnrollmentFileUploadApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enrollmentFileUploadFileUpload(version: string, file?: any, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling enrollmentFileUploadFileUpload.'
        );
      }
      const localVarPath = `/api/v{version}/documents/upload`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (file !== undefined) {
        localVarFormParams.append('File', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnrollmentFileUploadApi - functional programming interface
 * @export
 */
export const EnrollmentFileUploadApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enrollmentFileUploadFileUpload(
      version: string,
      file?: any,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetaData> {
      const localVarAxiosArgs = EnrollmentFileUploadApiAxiosParamCreator(configuration).enrollmentFileUploadFileUpload(
        version,
        file,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * EnrollmentFileUploadApi - factory interface
 * @export
 */
export const EnrollmentFileUploadApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} version
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enrollmentFileUploadFileUpload(version: string, file?: any, options?: any): AxiosPromise<FileMetaData> {
      return EnrollmentFileUploadApiFp(configuration).enrollmentFileUploadFileUpload(
        version,
        file,
        options
      )(axios, basePath);
    },
  };
};

/**
 * EnrollmentFileUploadApi - object-oriented interface
 * @export
 * @class EnrollmentFileUploadApi
 * @extends {BaseAPI}
 */
export class EnrollmentFileUploadApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnrollmentFileUploadApi
   */
  public enrollmentFileUploadFileUpload(version: string, file?: any, options?: any) {
    return EnrollmentFileUploadApiFp(this.configuration).enrollmentFileUploadFileUpload(
      version,
      file,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * FileDeleteApi - axios parameter creator
 * @export
 */
export const FileDeleteApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {FileDeleteCommand} fileMetaData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileDeleteFileDelete(version: string, fileMetaData: FileDeleteCommand, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling fileDeleteFileDelete.'
        );
      }
      // verify required parameter 'fileMetaData' is not null or undefined
      if (fileMetaData === null || fileMetaData === undefined) {
        throw new RequiredError(
          'fileMetaData',
          'Required parameter fileMetaData was null or undefined when calling fileDeleteFileDelete.'
        );
      }
      const localVarPath = `/api/v{version}/documents/delete`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
      const needsSerialization =
        typeof fileMetaData !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(fileMetaData !== undefined ? fileMetaData : {})
        : fileMetaData || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FileDeleteApi - functional programming interface
 * @export
 */
export const FileDeleteApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {FileDeleteCommand} fileMetaData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileDeleteFileDelete(
      version: string,
      fileMetaData: FileDeleteCommand,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = FileDeleteApiAxiosParamCreator(configuration).fileDeleteFileDelete(
        version,
        fileMetaData,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * FileDeleteApi - factory interface
 * @export
 */
export const FileDeleteApiFactory = function(configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {string} version
     * @param {FileDeleteCommand} fileMetaData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileDeleteFileDelete(version: string, fileMetaData: FileDeleteCommand, options?: any): AxiosPromise<void> {
      return FileDeleteApiFp(configuration).fileDeleteFileDelete(version, fileMetaData, options)(axios, basePath);
    },
  };
};

/**
 * FileDeleteApi - object-oriented interface
 * @export
 * @class FileDeleteApi
 * @extends {BaseAPI}
 */
export class FileDeleteApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {FileDeleteCommand} fileMetaData
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileDeleteApi
   */
  public fileDeleteFileDelete(version: string, fileMetaData: FileDeleteCommand, options?: any) {
    return FileDeleteApiFp(this.configuration).fileDeleteFileDelete(
      version,
      fileMetaData,
      options
    )(this.axios, this.basePath);
  }
}

/**
 * FileUploadsInProgressApi - axios parameter creator
 * @export
 */
export const FileUploadsInProgressApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileUploadsInProgressGet(version: string, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling fileUploadsInProgressGet.'
        );
      }
      const localVarPath = `/api/v{version}/documents/upload/inProgress`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FileUploadsInProgressApi - functional programming interface
 * @export
 */
export const FileUploadsInProgressApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileUploadsInProgressGet(
      version: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileUploadInProgressDto>> {
      const localVarAxiosArgs = FileUploadsInProgressApiAxiosParamCreator(configuration).fileUploadsInProgressGet(
        version,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * FileUploadsInProgressApi - factory interface
 * @export
 */
export const FileUploadsInProgressApiFactory = function(
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fileUploadsInProgressGet(version: string, options?: any): AxiosPromise<Array<FileUploadInProgressDto>> {
      return FileUploadsInProgressApiFp(configuration).fileUploadsInProgressGet(version, options)(axios, basePath);
    },
  };
};

/**
 * FileUploadsInProgressApi - object-oriented interface
 * @export
 * @class FileUploadsInProgressApi
 * @extends {BaseAPI}
 */
export class FileUploadsInProgressApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileUploadsInProgressApi
   */
  public fileUploadsInProgressGet(version: string, options?: any) {
    return FileUploadsInProgressApiFp(this.configuration).fileUploadsInProgressGet(version, options)(
      this.axios,
      this.basePath
    );
  }
}

/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    heartbeatGet(version: string, options: any = {}): RequestArgs {
      // verify required parameter 'version' is not null or undefined
      if (version === null || version === undefined) {
        throw new RequiredError(
          'version',
          'Required parameter version was null or undefined when calling heartbeatGet.'
        );
      }
      const localVarPath = `/api/v{version}/documents/heartbeat`.replace(
        `{${'version'}}`,
        encodeURIComponent(String(version))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function(configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    heartbeatGet(version: string, options?: any): AxiosPromise<void> {
      return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
    },
  };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
  /**
   *
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HeartbeatApi
   */
  public heartbeatGet(version: string, options?: any) {
    return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
  }
}
